<div class="flex-row">
  <div class="item">
    <rn-image-container [catalogRecord]="catalogRecord" alt="" maxHeight="image-small"/>
  </div>
  <div>
    <a (click)="routingService.goToCatalogRecordDetail(catalogRecord.id)">{{ catalogRecord.title }}</a>
    <div class="mat-caption">{{ barcode }}</div>
  </div>
</div>
